/**
 * @generated SignedSource<<3a12b0f25b29e60568126c3c83dffcf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item" | "PdpSharedBuyItNowButton_item">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_item";
};
export type PdpSharedShoppingButtons_item$key = {
  readonly " $data"?: PdpSharedShoppingButtons_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "67f08a79878a01e18caa6567fd3c4545";

export default node;
